module.exports = __webpack_public_path__ + "static/media/undraw_transfer_money_economy.3b944ad6.svg";